export const SIGNUP_ERROR_MESSAGES = {
  MISSING_FIELDS: 'Please enter all the fields to continue',
  INVALID_MAIL: 'Please enter a valid email address to continue',
  INVALID_WORK_MAIL: 'Please provide valid work email to continue',
  SIGNUP_TO_CONTINUE: 'Please signup to continue',
  GENERIC: 'Something went wrong',
};

export const WHITELISTED_DOMAINS = ['gmail.com', 'yahoo.com', 'hotmail.com'];
export const PASSWORD_HELP_MESSAGE =
  'Password should be greater than or equal to 12 characters and should include a combination of capital and small letters, a number, a special character and should not be starting or ending with space.';
export const FREETRIAL = 'freetrial';
export const OPENSOURCE = 'opensource';
